import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { AppUserService } from '../services/app-user.service';  // Service for fetching apps list
import { setAppList } from './app-state.actions';

@Injectable()
export class AppEffects {


  constructor(
    private actions$: Actions,
  ) {}
}
